import { Box, Icon, Text } from '@nimbus-ds/components';
import { TiendanubeIcon } from '@nimbus-ds/icons';

type D2cEventStatusType = {
  enable: boolean;
  message?: string | JSX.Element;
  url?: string;
};

const eventDates = {
  stepOne: {
    start: '2025-04-14T00:00:00',
    end: '2025-04-23T07:49:59',
  },
  stepTwo: {
    start: '2025-04-23T08:50:00',
    end: '2025-05-03',
  },
  stepThree: {
    start: '2025-05-04',
  },
};

export function getD2cEventStatus(): D2cEventStatusType {
  const now = new Date();
  const saoPauloTime = new Date(now.getTime() - 3 * 60 * 60 * 1000);

  const isoString = saoPauloTime.toISOString().slice(0, 19);
  const { stepOne, stepTwo } = eventDates;

  if (isoString >= stepOne.start && isoString <= stepOne.end) {
    return {
      enable: true,
      message: 'D2C Summit: Saiba primeiro. Inscreva-se',
      url: 'https://www.nuvemshop.com.br/eventos/d2c-summit?utm_source=userflow&utm_medium=modal-pm[…]=PMM-BR-Lifecycle-d2csummit&utm_content=modal-banner-admin',
    };
  }

  if (isoString >= stepTwo.start) {
    return {
      enable: true,
      message: (
        <Box display="flex" flexDirection="row" gap="2">
          <Icon
            color="neutral-background"
            source={<TiendanubeIcon size="small" />}
          />
          <Text color="neutral-background" lineClamp={1} as="span">
            {' '}
            D2C Summit:{' '}
            <Text as="span" color="neutral-background" fontWeight="bold">
              garanta seu desconto
            </Text>
          </Text>
        </Box>
      ),
      url: 'https://www.sympla.com.br/evento/d2c-summit/2918712?d=20-CLIENTE&utm_source=admin&utm_medium=banner-admin&utm_campaign=abertura-vendas-2304',
    };
  }

  return { enable: false };
}
